<template>
  <b-card>
    <b-card-header>({{selectedRestaurant.name}}) Bank Info</b-card-header>
    <b-card-body>
      <b-row>
        <b-col sm="12">
          <label>Acc Holder Name</label>
          <b-input v-model="bank_info.acc_holder_name"></b-input>
        </b-col>
        <b-col sm="12">
          <label>Account Number</label>
          <b-input v-model="bank_info.acc_number"></b-input>
        </b-col>
        <b-col sm="12">
          <label>Ifsc Code</label>
          <b-input v-model="bank_info.ifsc_code"></b-input>
        </b-col>
        <b-col sm="12">
          <label>Bank Name</label>
          <b-input v-model="bank_info.bank_name"></b-input>
        </b-col>
        <b-col sm="12">
          <b-button @click="saveInfo" variant="success" class="mt-4">Save</b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import axios from "axios";
import {RestaurantsPath} from "@/path";
import Swal from "sweetalert2";

export default {
  name: "bank-info",
  props : ['selectedRestaurant'],
  data(){
    return {
      bank_info : {},
      baseUrl : process.env.VUE_APP_API_BACKEND_URL
    }
  },
  mounted(){
    if(this.selectedRestaurant.bank_info){
      this.bank_info = this.selectedRestaurant.bank_info;
    }else{
      this.bank_info.res_id = this.selectedRestaurant.id;
    }
  },
  methods : {
    async saveInfo(){
      try {
        let res = await axios.post(this.baseUrl + RestaurantsPath.SAVE_BANK_INFO,this.bank_info);
        if(res.data.status){
          Swal.fire("success","","success");
        }else{
          Swal.fire("error","","error");
        }
        this.$bvModal.hide('bv-update-restaurant-bank-info');
        this.$emit('update');
      }catch (e) {
        console.log(e);
      }
    }
  }
}
</script>

<style scoped>

</style>